import { Link } from "react-router";
import * as React from "react";
import { useTranslation } from "react-i18next";
import useDisplayStickyButton from "~/hook/useDisplayStickyButton";
import { useFontStyle } from "~/hook/useFontStyle";
import { useLanguageParams } from "~/hook/useLanguageParams";
import { cn } from "~/lib/utils";
type Props = {
  isMobile?: boolean;
};
const HeaderImage: React.FC<Props> = ({ isMobile = false }) => {
  const { t } = useTranslation();
  const { regular, normalInter } = useFontStyle();
  const { isSticky } = useDisplayStickyButton();
  const lang = useLanguageParams();
  return (
    <Link
      // w-[250px] md:w-[100px]  lg:w-[300px] 2xl:w-[350px]
      className="h-[60px] flex justify-center md:justify-start lg:justify-center items-center cursor-pointer space-x-2"
      to={`/${lang}`}
    >
      <div className="w-[45px] h-[45px] lg:w-[50px] lg:h-[50px] aspect-square rounded-full ">
        <img src="/images/maharaj-header-icon.webp" alt="swaminarayan bhagawan" className="w-full h-full select-none pointer-events-none" />
      </div>

      <div className={cn("leading-5 text-start select-none", isMobile ? "block lg:hidden 2xl:block" : "block lg:block")}>
        {/* <h1 className={cn("font-abcArizonaFlareVariable text-textColorPrimary body_text_m", regular)}>
          {t("common.heading", { defaultValue: "Shree Swaminarayan Temple" })}
        </h1>
        <p className={cn("body_text_xs font-sans text-textSecondaryColor", normalInter)}>
          {t("common.sub-heading", { defaultValue: "Karelibaug • Vadodara | Kundaldham" })}
        </p> */}

        <p className="font-abcArizonaFlareVariable xs:text-center smd:text-start text-textColorPrimary body_text_m">Shree Swaminarayan Temple</p>
        <p className={cn("xs:hidden smd:block sml:block body_text_xs font-outfitRegular text-textSecondaryColor")}>
          Karelibaug - Vadodara | Kundaldham
        </p>
      </div>
    </Link>
  );
};

export default HeaderImage;
